/* eslint-disable @typescript-eslint/camelcase */
import {
    actionTypeStatusChanged,
    actionTypeUploadingDocument,
    archivedStatus,
    doneRecognitionStatus,
    errorRecognitionStatus,
    recognizingRecognitionStatus,
    requestStatusError,
    requestStatusRunning,
    requestStatusSuccess,
    unarchivedStatus,
    waitingRecognitionStatus,
    customTokenSourceApiAsync,
    customTokenSourceApiSync,
    customTokenSourceWeb,
    webhookStatusNotSent,
    statusApprovalApproved,
} from '../../constants';

export default {
    translation: {
        Tesseract: 'Tesseract',
        Azure: 'Azure',
        Google: 'Google',
        Textract: 'Textract',
        auto: 'Auto',
        always: 'Always',
        never: 'Never',
        Admin: 'Admin',
        Operator: 'Operator',
        User: 'User',
        Currency: 'Currency',
        breadcrumbs: {
            ruleConfigs: 'Rules config',
            rules_config: 'Rules config',
            export_config: 'Export config',
            exportConfigs: 'Export config',
            rulesConfigs: 'Rules config',
            integrations: 'Integrations',
            rules: 'Rules',
            404: '404',
            500: '500',
            app: 'App',
            news: 'News',
            horizontal: 'Horizontal',
            horizontalMenu: 'Horizontal Menu',
            general: 'General',
            component: 'Component',
            features: 'Features',
            applications: 'Applications',
            documents: 'Documents',
            userDocuments: 'User documents',
            invoices: 'Invoices',
            taxForms: 'Tax forms',
            dashboard: 'Dashboard',
            dashboard1: 'Dashboard 1',
            dashboard2: 'Dashboard 2',
            dashboard3: 'Dashboard 3',
            modules: 'Modules',
            agency: 'Agency',
            pages: 'Pages',
            gallery: 'Gallery',
            pricing: 'Pricing',
            'terms&Conditions': 'Terms & Conditions',
            feedback: 'Feedback',
            report: 'Report',
            'faq(s)': 'Faq(s)',
            whatsNew: 'What\'s new',
            advancedComponent: 'Advance Component',
            blank: 'Blank',
            session: 'Session',
            login: 'Login',
            register: 'Register',
            lockScreen: 'Lock Screen',
            forgotPassword: 'Forgot Password',
            uiComponents: 'UI Components',
            alerts: 'Alerts',
            appBar: 'App Bar',
            avatars: 'Avatars',
            buttons: 'Buttons',
            bottomNavigations: 'Bottom Navigations',
            badges: 'Badges',
            cards: 'Cards',
            cardsMasonry: 'Cards Masonry',
            chip: 'Chip',
            dialog: 'Dialog',
            dividers: 'Dividers',
            drawers: 'Drawers',
            popover: 'Popover',
            expansionPanel: 'Expansion Panel',
            gridList: 'Grid List',
            list: 'List',
            menu: 'Menu',
            popoverAndToolTip: 'Pop Over & ToolTip',
            progress: 'Progress',
            snackbar: 'Snackbar',
            selectionControls: 'Selection Controls',
            advanceUiComponents: 'Advance UI Components',
            dateAndTimePicker: 'Date & Time Picker',
            tabs: 'Tabs',
            stepper: 'Stepper',
            notification: 'Notification',
            sweetAlert: 'Sweet Alert',
            autoComplete: 'Auto Complete',
            aboutUs: 'About Us',
            widgets: 'Widgets',
            forms: 'Forms',
            formElements: 'Form Elements',
            textField: 'Text Field',
            selectList: 'Select List',
            charts: 'Charts',
            reCharts: 'Re Charts',
            reactChartjs2: 'React Chartjs 2',
            icons: 'Icons',
            themifyIcons: 'Themify Icons',
            simpleLineIcons: 'Simple Line Icons',
            materialIcons: 'Material Icons',
            fontAwesome: 'Font Awesome',
            tables: 'Tables',
            basic: 'Basic',
            dataTable: 'Data Table',
            responsive: 'Responsive',
            reactTable: 'React Table',
            maps: 'Maps',
            googleMaps: 'Google Maps',
            leafletMaps: 'Leaflet Maps',
            inbox: 'Inbox',
            users: 'Users',
            userProfile1: 'User Profile 1',
            userProfile2: 'User Profile 2',
            userManagement: 'User Management',
            userProfile: 'User Profile',
            userList: 'User List',
            calendar: 'Calendar',
            cultures: 'Cultures',
            dnd: 'Dnd',
            selectable: 'Selectable',
            customRendering: 'Custom Rendering',
            chat: 'Chat',
            toDo: 'ToDo',
            editor: 'Editor',
            wysiwygEditor: 'WYSIWYG Editor',
            quillEditor: 'Quill Editor',
            reactAce: 'React Ace',
            dragAndDrop: 'Drag And Drop',
            reactDragula: 'React Dragula',
            reactDnd: 'React Dnd',
            blogManagement: 'Blog Management',
            ecommerce: 'Ecommerce',
            shopList: 'Shop List',
            shopGrid: 'Shop Grid',
            invoice: 'Invoice',
            multilevel: 'Multilevel',
            sublevel: 'Sublevel',
            crypto: 'Crypto',
            marketCap: 'Market cap',
            wallet: 'wallet',
            trade: 'trade',
            crm: 'CRM',
            dateTimePicker: 'Date & Time Picker',
            user: 'User',
            miscellaneous: 'Miscellaneous',
            promo: 'Promo',
            gettingStarted: 'Getting Started',
            shop: 'Shop',
            cart: 'Cart',
            checkout: 'Checkout',
            saas: 'SAAS',
            multiLevel: 'MultiLevel',
            level1: 'Level 1',
            level2: 'Level 2',
            boxed: 'Boxed',
            extensions: 'Extensions',
            imageCropper: 'Image Cropper',
            videoPlayer: 'Video Player',
            dropzone: 'Dropzone',
            projects: 'projects',
            projectDetail: 'project Detail',
            clients: 'clients',
            reports: 'reports',
            create: 'Create',
            taxforms: 'Tax forms',
            profile: 'Profile',
            apiKeys: 'Api keys',
            suppliers: 'Suppliers',
            tags: 'Tags',
            documentTypes: 'Document types',
            templates: 'Templates',
            userHistory: 'Actions',
            requests: 'Requests',
            templateCollections: 'Template collections',
            plan: 'Plan'
        },
        widgets: {
            user_tour: 'Start user tour',
            totalEarns: 'Total Earns',
            emailsStatistics: 'Emails Statistics',
            totalRevenue: 'Total Revenue',
            onlineVistors: 'Online Vistors',
            trafficSources: 'Traffic Sources',
            RecentOrders: 'Recent Orders',
            topSellings: 'Top Sellings',
            productReports: 'Product Reports',
            productStats: 'Product Stats',
            ComposeEmail: 'Compose Email',
            employeePayroll: 'Employee Payroll',
            visitors: 'Visitors',
            orders: 'Orders',
            orderStatus: 'Order Status',
            totalSales: 'Total Sales',
            netProfit: 'Net Profit',
            overallTrafficStatus: 'Overall Traffic Status',
            tax: 'Tax',
            expenses: 'Expenses',
            currentTime: 'Current Time',
            currentDate: 'Current Date',
            todayOrders: 'Today Orders',
            toDoList: 'To Do Lists',
            discoverPeople: 'Discover People',
            commments: 'Comments',
            newCustomers: 'New Customers',
            recentNotifications: 'Recent Notifications',
            appNotifications: 'App Notifications',
            ratings: 'Ratings',
            newEmails: 'New Emails',
            siteVisitors: 'Site Visitors',
            socialCompanines: 'Social Companines',
            recentActivities: 'Recent Activities',
            recentOrders: 'Recent Orders',
            gallery: 'Gallery',
            pricing: 'Pricing',
            enterpriseEdition: 'Enterprise Edition',
            personalEdition: 'Personal Edition',
            teamEdition: 'Team Edition',
            standard: 'Standard',
            advanced: 'Advanced',
            master: 'Master',
            Mega: 'Mega',
            logIn: 'Log In',
            signUp: 'Sign Up',
            lockScreen: 'Lock Screen',
            alertsWithLink: 'Alerts With Link',
            additionalContent: 'Additional Content',
            alertDismiss: 'Alert Dismiss',
            uncontrolledDisableAlerts: 'Uncontrolled Disable Alerts',
            contexualAlerts: 'Contexual Alerts',
            alertsWithIcons: 'Alerts With Icons',
            'Simple App Bars': 'Simple App Bars',
            appBarsWithButtons: 'App Bars With Buttons',
            imageAvatars: 'Image Avatars',
            lettersAvatars: 'Letters Avatars',
            iconsAvatars: 'Icons Avatars',
            flatButtons: 'Flat Buttons',
            raisedButton: 'Raised Button',
            buttonWithIconAndLabel: 'Button With Icon And Label',
            floatingActionButtons: 'Floating Action Buttons',
            iconButton: 'Icon Button',
            socialMediaButton: 'Social Media Button',
            reactButton: 'React Button',
            buttonOutline: 'Button Outline',
            buttonSize: 'Button Size',
            buttonState: 'Button State',
            buttonNavigationWithNoLabel: 'button Navigation With No Label',
            buttonNavigation: 'Button Navigation',
            iconNavigation: 'Icon Navigation',
            badgeWithHeadings: 'Badge With Headings',
            contexualVariations: 'Contexual Variations',
            badgeLinks: 'Badge Links',
            materialBadge: 'Material Badge',
            simpleCards: 'Simple Cards',
            backgroundVarient: 'Background Varient',
            cardOutline: 'Card Outline',
            overlayCard: 'Overlay Card',
            cardGroup: 'Card Group',
            cardTitle: 'Card Title',
            speacialTitleTreatment: 'Speacial Title Treatment',
            chipWithClickEvent: 'Chip With Click Event',
            chipArray: 'Chip Array',
            dialogs: 'Dialogs',
            listDividers: 'List Dividers',
            insetDividers: 'Inset Dividers',
            temporaryDrawers: 'Temporary Drawers',
            permanentDrawers: 'Permanent Drawers',
            simpleExpansionPanel: 'Simple Expansion Panel',
            controlledAccordion: 'Controlled Accordion',
            secondaryHeadingAndColumns: 'Secondary Heading And Columns',
            imageOnlyGridLists: 'Image Only Grid Lists',
            advancedGridLists: 'Advanced Grid Lists',
            singleLineGridLists: 'Single Line Grid Lists',
            simpleLists: 'Simple Lists',
            folderLists: 'Folder Lists',
            listItemWithImage: 'List Item With Image',
            switchLists: 'Switch Lists',
            insetLists: 'Inset Lists',
            nestedLists: 'Nested Lists',
            checkboxListControl: 'Checkbox List Control',
            pinedSubHeader: 'Pined Sub Header',
            InteractiveLists: 'Interactive Lists',
            simpleMenus: 'Simple Menus',
            selectedMenu: 'Selected Menu',
            maxHeightMenu: 'Max Height Menu',
            changeTransition: 'Change Transition',
            paper: 'Paper',
            anchorPlayGround: 'Anchor Play Ground',
            tooltip: 'ToolTip',
            positionedToolTips: 'Positioned Snackbar',
            circularProgressBottomStart: 'Circular Progress Bottom Start',
            interactiveIntegration: 'Interactive Integration',
            determinate: 'Determinate',
            linearProgressLineBar: 'Linear Progress Line Bar',
            indeterminate: 'Indeterminate',
            buffer: 'Buffer',
            query: 'Query',
            transitionControlDirection: 'Transition Control Direction',
            simpleSnackbar: 'Simple Snackbar',
            positionedSnackbar: 'Positioned Snackbar',
            contexualColoredSnackbars: 'Contexual Colored Snackbars',
            simpleCheckbox: 'Simple Checkbox',
            interminateSelection: 'Interminate Selection',
            disabledCheckbox: 'Disabled Checkbox',
            customColorCheckbox: 'Custom Color Checkbox',
            VerticalStyleCheckbox: 'Vertical Style Checkbox',
            horizontalStyleCheckbox: 'Horizontal Style Checkbox',
            radioButtons: 'Radio Buttons',
            disabledRadio: 'Disabled Radio',
            withError: 'With Error',
            switches: 'Swiches',
            dateAndTimePicker: 'Date And Time Picker',
            defaultPicker: 'Default Picker',
            timePicker: 'Time Picker',
            weekPicker: 'Week Picker',
            defaultDatePicker: 'Default Date Picker',
            customPicker: 'Custom Picker',
            tabs: 'Tabs',
            fixedTabs: 'Fixed Tabs',
            basicTab: 'Basic Tab',
            wrappedLabels: 'Wrapped Labels',
            centeredLabels: 'Centered Labels',
            forcedScrolledButtons: 'Forced Scrolled Buttons',
            iconsTabs: 'Icons Tabs',
            withDisableTabs: 'With Disable Tabs',
            iconWithLabel: 'Icon With Label',
            stepper: 'Stepper',
            horizontalLinear: 'Horizontal Linear',
            horizontalNonLinear: 'Horizontal Non Linear',
            horizontalLinerAlternativeLabel: 'Horizontal Liner Alternative Label',
            horizontalNonLinerAlternativeLabel: 'Horizontal Non Liner Alternative Label',
            verticalStepper: 'Vertical Stepper',
            descriptionAlert: 'Description Alert',
            customIconAlert: 'Custom Icon Alert',
            withHtmlAlert: 'With Html Alert',
            promptAlert: 'Prompt Alert',
            passwordPromptAlert: 'Password Prompt Alert',
            customStyleAlert: 'Custom Style Alert',
            autoComplete: 'Auto Complete',
            reactSelect: 'React Select',
            downshiftAutoComplete: 'Downshift Auto Complete',
            reactAutoSuggests: 'React Auto Suggests',
            aboutUs: 'About Us',
            ourVission: 'Our Vission',
            ourMissions: 'Our Missions',
            ourMotivation: 'Our Motivation',
            defualtReactForm: 'Defualt React Form',
            url: 'Url',
            textArea: 'Text Area',
            file: 'File',
            formGrid: 'Form Grid',
            inlineForm: 'Inline Form',
            inputSizing: 'Input Sizing',
            inputGridSizing: 'Input Grid Sizing',
            hiddenLabels: 'Hidden Labels',
            formValidation: 'Form Validation',
            number: 'Number',
            date: 'Date',
            time: 'Time',
            color: 'Color',
            search: 'Search',
            selectMultiple: 'Select Multiple',
            inputWithSuccess: 'Input With Success',
            inputWithDanger: 'Input With Danger',
            simpleTextField: 'Simple Text Field',
            componet: 'Components',
            layouts: 'Layouts',
            inputAdorements: 'Input Adorements',
            formattedInputs: 'Formatted Inputs',
            simpleSelect: 'Simple Select',
            nativeSelect: 'Native Select',
            MutltiSelectList: 'Mutlti Select List',
            lineChart: 'Line Chart',
            barChart: 'Bar Chart',
            stackedBarChart: 'Stacked Bar Chart',
            lineBarAreaChart: 'Line Bar Area Chart',
            areaChart: 'Area Chart',
            stackedAreaChart: 'Stacked Area Chart',
            verticalChart: 'Vertical Chart',
            radarChart: 'Radar Chart',
            doughnut: 'Doughnut',
            polarChart: 'Polar Chart',
            pieChart: 'Pie Chart',
            bubbleChart: 'Bubble Chart',
            horizontalBar: 'Horizontal Bar',
            basicTable: 'Basic Table',
            contexualColoredTable: 'Contexual Colored Table',
            dataTable: 'Data Table',
            employeeList: 'Employee List',
            responsiveTable: 'Responsive Table',
            responsiveFlipTable: 'Responsive Flip Table',
            reactGridControlledStateMode: 'React Grid Controlled State Mode',
            productsReports: 'Products Reports',
            taskList: 'Task List',
            basicCalender: 'Basic Calender',
            culturesCalender: 'Cultures Calender',
            dragAndDropCalender: 'Drag And Drop Calender',
            selectableCalender: 'Selectable Calender',
            customRendering: 'Custom Rendering',
            customCalender: 'Custom Calender',
            searchMailList: 'Search Mail List',
            forgetPassword: 'Forget Password',
            QuickLinks: 'Quick Links',
            app: 'App',
            addNew: 'Add New',
            orderDate: 'Order Date',
            status: 'Status',
            trackingNumber: 'Tracking Number',
            action: 'Action',
            designation: 'Designation',
            subject: 'subject',
            send: 'Send',
            saveAsDrafts: 'Save As Drafts',
            onlineSources: 'Online Sources',
            lastMonth: 'Last Month',
            widgets: 'Widgets',
            listing: 'Listing',
            paid: 'Paid',
            refunded: 'Refunded',
            done: 'Done',
            pending: 'Pending',
            cancelled: 'Cancelled',
            approve: 'Approve',
            following: 'Following',
            follow: 'follow',
            'graphs&Charts': 'Graphs & Charts',
            open: 'Open',
            bounced: 'Bounced',
            spam: 'Spam',
            unset: 'Unset',
            bandwidthUse: 'Bandwidth Use',
            dataUse: 'Data Use',
            unsubscribe: 'Unsubscribe',
            profile: 'Profile',
            messages: 'Messages',
            support: 'Support',
            'faq(s)': 'Faq(s)',
            upgradePlains: 'Upgrade Plains',
            logOut: 'Log Out',
            mail: 'Mail',
            adminTheme: 'Admin Theme',
            wordpressTheme: 'Wordpress Theme',
            addToCart: 'Add To Cart',
            plan: 'Plan',
            pro: 'Pro',
            standardOcr: 'Standard OCR',
            advancedOcr: 'Advanced OCR',
            dataExtraction: 'Data extraction',
            upgrade: 'Upgrade',
            onPlan: 'On Plan',
            startToFree: 'Start To Free',
            upgradeToPro: 'Upgrade To Pro',
            upgradeToAdvance: 'Upgrade To Advance',
            comparePlans: 'Compare Plans',
            basic: 'Basic',
            free: 'Free',
            frequentlyAskedQuestions: 'Frequently Asked Questions',
            searchIdeas: 'Search Ideas',
            startDate: 'Start Date',
            endDate: 'End Date',
            category: 'Category',
            apply: 'Apply',
            yesterday: 'Yesterday',
            totalOrders: 'Total Orders',
            totalVisitors: 'Total Visitors',
            typeYourQuestions: 'Type Your Questions',
            username: 'Username',
            password: 'Password',
            signIn: 'Sign In',
            enterYourPassword: 'Enter Your Password',
            alreadyHavingAccountLogin: 'Already Having Account Login',
            composeMail: 'Compose Mail',
            issue: 'Issue',
            recentChat: 'Recent Chat',
            previousChat: 'Previous Chat',
            all: 'All',
            filters: 'Filters',
            deleted: 'Deleted',
            starred: 'Starred',
            frontend: 'Frontend',
            backend: 'Backend',
            api: 'Api',
            simpleAppBar: 'Simple App Bar',
            recents: 'Recents',
            cardLink: 'Card Link',
            anotherLink: 'Another Link',
            cardSubtitle: 'card Subtitle',
            confirmationDialogs: 'Confirmation Dialogs',
            deletableChip: 'Deletable Chip',
            customDeleteIconChip: 'Custom Delete Icon Chip',
            openAlertDialog: 'Open Alert Dialog',
            openResponsiveDialog: 'Open Responsive Dialog',
            openSimpleDialog: 'Open Simple Dialog',
            openFormDialog: 'Open Form Dialog',
            follower: 'Follower',
            important: 'Important',
            private: 'Private',
            openLeft: 'Open Left',
            openRight: 'Open Right',
            openTop: 'Open Top',
            openBottom: 'Open Bottom',
            selectTripDestination: 'Select Trip Destination',
            pinnedSubheaderList: 'Pinned Subheader List',
            singleLineItem: 'Single Line Item',
            optionA: 'Option A',
            optionB: 'Option B',
            optionC: 'Option C',
            optionM: 'Option M',
            optionN: 'Option N',
            optionO: 'Option O',
            customColor: 'Custom Color',
            centeredTabs: 'Centered Tabs',
            multipleTabs: 'Multiple Tabs',
            preventScrolledButtons: 'Prevent Scrolled Buttons',
            browse: 'Browse',
            formValidate: 'Form Validate',
            code: 'Code',
            company: 'Company',
            price: 'Price',
            change: 'Change',
            high: 'High',
            low: 'Low',
            volume: 'Volume',
            personalDetails: 'Personal Details',
            occupation: 'Occupation',
            companyName: 'Company Name',
            phoneNo: 'Phone No',
            updateProfile: 'Update Profile',
            reject: 'Reject',
            exportToExcel: 'Export To Excel',
            workWeek: 'Work Week',
            agenda: 'Agenda',
            conference: 'Conference',
            multilevel: 'Multilevel',
            dailySales: 'Daily Sales',
            today: 'Today',
            campaignPerformance: 'Campaign Performance',
            supportRequest: 'Support Request',
            usersList: 'UserProfile List ',
            lastWeek: 'Last Week',
            buyMore: 'Buy More',
            trafficChannel: 'Traffic Channel',
            stockExchange: 'Stock Exchange',
            tweets: 'Tweets',
            ourLocations: 'Our Locations',
            sales: 'Sales',
            to: 'To',
            shipTo: 'Ship To',
            description: 'Description',
            unitPrice: 'Unit Price',
            total: 'Total',
            note: 'Note',
            chipWithAvatar: 'Chip With Avatar',
            chipWithTextAvatar: 'Chip With Text Avatar',
            chipWithIconAvatar: 'Chip With Icon Avatar',
            customClickableChip: 'Custom Clickable Chip',
            outlineChip: 'Outline Chip',
            disableChip: 'Disable Chip',
            alertDialog: 'Alert Dialog',
            animatedSlideDialogs: 'Animated Slide Dialogs',
            fullScreenDialogs: 'Full Screen Dialogs',
            formDialogs: 'Form Dialogs',
            simpleDialogs: 'Simple Dialogs',
            responsiveFullScreen: 'Responsive Full Screen',
            primary: 'Primary',
            social: 'Social',
            user: 'User',
            admin: 'Admin',
            permanentdrawer: 'Permanent Drawer',
            persistentdrawer: 'Persistent Drawer',
            swiches: 'Swiches',
            horizontalLinearAlternativeLabel: 'Horizontal Linear Alternative Label',
            horizontalNonLinearAlternativeLabel: 'Horizontal Non Linear Alternative Label',
            notifications: 'Notifications',
            basicAlert: 'Basic Alert',
            successAlert: 'Success Alert',
            warningAlert: 'Warning Alert',
            reactAutoSuggest: 'React Auto Suggest',
            components: 'Components',
            inputAdornments: 'Input Adorements',
            multiSelectList: 'Multi Select List',
            contextualColoredTable: 'Contexual Colored Table',
            updateYourEmailAddress: 'Update Your Email Address',
            selectADefaultAddress: 'Select A Default Address',
            activity: 'Activity',
            basicCalendar: 'Basic Calendar',
            culturesCalendar: 'Cultures Calendar',
            dragAndDropCalendar: 'Drag And Drop Calendar',
            quillEditor: 'Quill Editor',
            reactDND: 'React DND',
            dragula: 'Dragula',
            AcceptorrRejectWithin: 'Accept or reject within',
            quoteOfTheDay: 'Quote Of The Day',
            updated10Minago: 'Updated 10 min ago',
            personalSchedule: 'Personal Schedule',
            activeUsers: 'Active UserProfile',
            totalRequest: 'Total Request',
            new: 'New',
            ShareWithFriends: 'Share with friends!',
            helpToShareText: 'Help us spread the world by sharing our website with your friends and followers on social media!',
            thisWeek: 'This Week',
            howWouldYouRateUs: 'How would you rate us?',
            booking: 'Booking',
            confirmed: 'Confirmed',
            monthly: 'Monthly',
            weekly: 'Weekly',
            target: 'Target',
            totalActiveUsers: 'Total Active UserProfile',
            deadline: 'Deadline',
            team: 'Team',
            projectManagement: 'Project Management',
            latestPost: 'Latest Post',
            projectTaskManagement: 'Project Task Management',
            selectProject: 'Select Project',
            activityBoard: 'Activity Board',
            checklist: 'Checklist',
            baseConfig: 'Base Config',
            customControlBar: 'Custom Control Bar',
            withDownloadButton: 'With Download Button',
            httpLiveStreaming: 'HTTP Live Streaming',
            keyboardShortcuts: 'Keyboard Shortcuts',
            preview: 'Preview',
            croppedImage: 'Cropped Image',
            transactionList: 'Transaction List',
            transferReport: ' Transfer Report',
            expenseCategory: 'Expense Category',
            upcomingEvents: 'Upcoming events',
            OngoingProjects: 'Ongoing Projects',
            ProjectStatus: 'Project Status',
            LiveChatSupport: 'Live Chat Support',
            defaultSelectItem: 'Any',
        },
        components: {
            buyNow: 'Buy Now',
            alreadyHavingAccountSignIn: 'Already Having Account Sign In',
            enterYourPassword: 'Enter Your Password',
            unlock: 'Unlock',
            enterPasswords: 'Enter Passwords',
            resestPassword: 'Resest Password',
            pageNotfound: 'Page not Found',
            goToHomePage: 'Go To Home Page',
            sorryServerGoesWrong: 'Sorry Server Goes Wrong',
            persistentDrawer: 'Persistent Drawer',
            withHtml: 'With Html',
            prompt: 'Prompt',
            withDescription: 'With Description',
            success: 'Success',
            passwordPrompt: 'Password Prompt',
            warning: 'Warning',
            customIcon: 'Custom Icon',
            customStyle: 'Custom Style',
            basic: 'Basic',
            submit: 'Submit',
            compose: 'Compose',
            sendMessage: 'Send Message',
            addNewTasks: 'Add New Tasks',
            addToCart: 'Add To Cart',
            payNow: 'Pay Now',
            print: 'Print',
            cart: 'Cart',
            viewCart: 'View Cart',
            checkout: 'Checkout',
            summary: 'Summary',
            yesterday: 'Yesterday',
            last7Days: 'Last 7 Days',
            last1Month: 'Last 1 Month',
            last6Month: 'Last 6 Month',
            spaceUsed: 'Space Used',
            followers: 'Follower',
            trending: 'Trending',
            paid: 'Paid',
            refunded: 'Refunded',
            done: 'Done',
            pending: 'Pending',
            cancelled: 'Cancelled',
            approve: 'Approve',
            week: 'Week',
            month: 'Month',
            year: 'Year',
            today: 'Today',
            popularity: 'Popularity',
            email: 'Email',
            drafts: 'Drafts',
            sent: 'Sent',
            trash: 'Trash',
            all: 'All',
            do: 'Do',
            title: 'Title',
            projectName: 'Project Name',
            companyName: 'Company Name',
            openAlert: 'Open Alert',
            slideInAlertDialog: 'Slide In Alert Dialog',
            openFullScreenDialog: 'Open Full Screen Dialogs',
            basicChip: 'Basic Chip',
            clickableChip: 'Clickable Chip',
            left: 'Left',
            right: 'Right',
            expansionPanel1: 'Expansion Panel 1',
            expansionPanel2: 'Expansion Panel 2',
            generalSetting: 'General Setting',
            advancedSettings: 'Advanced Settings',
            firstName: 'First Name',
            lastName: 'Last Name',
            occupation: 'Occupation',
            phoneNo: 'Phone No',
            address: 'Address',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            'social Connection': 'Social Connection',
            emailPrefrences: 'Email Prefrences',
            myProfile: 'My Profile',
            product: 'Product',
            quantity: 'Quantity',
            totalPrice: 'Total Price',
            removeProduct: 'Remove Product',
            mobileNumber: 'Mobile Number',
            address2Optional: 'Address 2 (Optional)',
            country: 'Country',
            zip: 'Zip',
            saveContinue: 'Save & Continue',
            placeOrder: 'Place Order',
            payment: 'Payment',
            billingAddress: 'Billing Address',
            ShippingAddressText: 'Shipping address is the same as billing address.',
            CartEmptyText: 'Your Shopping Cart Is Empty!',
            NoItemFound: 'No Item Found',
            goToShop: 'Go To Shop',
            cardNumber: 'Card Number',
            expiryDate: 'Expiry Date',
            cvv: 'CVV',
            nameOnCard: 'Name On Card',
            confirmPayment: 'Confirm Payment',

            defaultConfirmDeleteDialogTitle: 'Delete confirmation',
            defaultConfirmDeleteDialogContent: 'Do you confirm deletion of current entity with id {{id}}?'
        },
        compenets: {
            choose: 'Choose',
            username: 'Username',
            passwords: 'Passwords',
            signIn: 'Sign In',
            dontHaveAccountSignUp: 'Dont Have Account SignUp',
            enterUserName: 'Enter User Name',
            enterEmailAddress: 'Enter Email Address',
            confirmPasswords: 'Confirm Passwords'
        },
        themeOptions: {
            sidebarOverlay: 'Sidebar Overlay',
            sidebarBackgroundImages: 'Sidebar Background Images',
            appSettings: 'App Settings',
            sidebarImage: 'Sidebar Image',
            miniSidebar: 'Mini Sidebar',
            boxLayout: 'Box Layout',
            rtlLayout: 'Rtl Layout',
            darkMode: 'Dark Mode',
            sidebarLight: 'Light',
            sidebarDark: 'Dark',
            themeColor: 'Theme Color'
        },
        button: {
            cancel: 'Cancel',
            add: 'Add',
            update: 'Update',
            reply: 'Reply',
            delete: 'Delete',
            yes: 'Yes',
            viewAll: 'View All',
            like: 'Like',
            assignNow: 'Assign Now',
            seeInsights: 'See Insights',
            acceptTerms: 'Accept Terms',
            reject: 'Reject',
            addNew: 'Add New',
            goToCampaign: 'Go To Campaign',
            viewProfile: 'View Profile',
            sendMessage: 'Send Message',
            saveNow: 'Save Now',
            pen: 'Pen',
            search: 'Search',
            downloadPdfReport: 'Download Pdf Report',
            primary: 'Primary',
            secondary: 'Secondary',
            danger: 'Danger',
            info: 'Info',
            success: 'Success',
            warning: 'Warning',
            link: 'Link',
            smallButton: 'Small Button',
            largeButton: 'Large Button',
            blockLevelButton: 'Block Level Button',
            primaryButton: 'Primary Button',
            button: 'Button',
            save: 'Save',
            openMenu: 'Open Menu',
            openWithFadeTransition: 'Open With Fade Transition',
            openPopover: 'Open Popover',
            accept: 'Accept',
            click: 'Click',
            complete: 'Complete',
            back: 'Back',
            next: 'Next',
            completeStep: 'Complete Step',
            error: 'Error',
            writeNewMessage: 'Write New Message',
            saveChanges: 'Save Changes',
            addNewUser: 'Add New User',
            more: 'More',
            useDefaultImage: 'Use Default Image',
            cropImage: 'Crop Image'
        },
        hint: {
            whatAreYouLookingFor: 'What are You Looking For',
            searchMailList: 'Search Mail List'
        },
        module: {
            inbox: 'Inbox',
            drafts: 'Drafts',
            sent: 'Sent',
            trash: 'Trash',
            spam: 'Spam',
            frontend: 'Frontend',
            backend: 'Backend',
            api: 'Api',
            issue: 'Issue'
        },
        auth: {
            actions: {
                success_logout: 'Successfully logged out',
                success_sign_in: 'Successfully logged in',
                success_sign_up: 'User successfully created'
            }
        },
        login: {
            fields: {
                username: 'Username',
                email: 'Email',
                password: 'Password'
            }
        },
        actions: {
            save: 'Save',
            sign_up: 'Sign up',
            sign_in: 'Sign in',
            delete: 'Delete',
            export: 'Export',
            close: 'Close'
        },
        common: {
            about: 'About',
            contactUs: 'Contact us!',
            choosePlan: 'Choose better plan!',
            contactUsTemplateText: 'Hi! I would like to upgrade my plan and increase my page limit. Please send me details.',
            contactUsDialogTitle: 'Limit exceeded',
            contactUsDialogContent: 'You have exceeded the limit of free recognitions for current period. ' +
                'Please, contact us in order to get unlimited access to the service.',
            dashboard: 'Dashboard',
            email: 'E-mail',
            username: 'Username',
            configuration: 'Configuration',
            profile: 'Profile',
            history: 'History',
            columns: 'Columns',
            line: 'Line',
            position: 'Position',
            error: 'Error',
            id: 'Id',
            none: 'None',
            optional: '(optional)',
            no_download_file: 'There is no file to download',
            status: 'Status',
            here: 'here',
            toLowercase: 'to',
            forgotPasswordQuestion: 'Forgot password?',
            resource_not_found_error: '{{resourceName}} with id {{id}} not found or not available for current user.',
            troubleshooting_title: 'Choose action',
            actions: {
                ok: 'OK',
                show_more: 'Show more',
                show_more_click: 'Click to show more',

                image_click: 'Click to show image',
                failed_to_load_image: 'Failed to load image',

                upgrade_plan: 'Upgrade plan',

                remove: 'Remove',

                update_data: 'Update data',

                move_back: 'Mode back',
                move_forward: 'Move forward',

                add: 'Add',
                prev: 'Prev',
                next: 'Next',

                delete: 'Delete',
                close: 'Close',
                click: 'Click',
                download_file: 'Download file',
                change_password: 'Change password',
                generateApiKey: 'Generate Key',

                add_new_column: 'Column',
                add_new_row: 'Row',

                moreInfo: 'More Information',

                save: 'Save',
                edit: 'Edit',
                show: 'Show',
                submit: 'Submit',

                signUp: 'Sign up',

                confirm: 'Confirm',
                cancel: 'Cancel',
                create: 'Create',

                ocr_text: 'Recognized text (TXT)',
                recognizedPdf: 'Recognized pdf (PDF)',
                csv: 'Extracted values (CSV)',
                xlsx: 'Extracted values (XLSX)',
                json: 'Extracted values (JSON)',

                server_error: 'Server error',
                approve: 'Verify',
                upload: 'Upload',
                download: 'Download',
                more: 'More',

                archive: 'Archive',
                unarchive: 'Unarchive',

                make_paid: 'Mark as Paid',
                make_unpaid: 'Mark as Unpaid',

                template: 'Template',

                make_payable: 'Make payable',
                make_receivable: 'Make receivable',

                export: 'Export',
                export_login_success: 'Xero login success',
                export_success: 'Xero success',
                export_error: 'Xero error',
                exportItems: 'Xero Items',
                exportTotal: 'Xero Total',
                export_acs: 'Export to AccountingSuite',

                getXeroExportOptionsError:
                    'Error when trying to fetch options for export document type %{type}',

                format: 'Format',

                mergeDocument: 'Merge',
                splitDocument: 'Split',

                reRun: 'Re-run',
                reRunSplitting: 'Re-split',
                processAnyway: 'Process anyway',

                calculateFields: 'Calculate fields',

                enable: 'Enable',
                disable: 'Disable',
            },
            validation: {
                required: 'Required',
                minValue: 'Must be at least {{min}}',
                incorrect_number: 'The value must be a number',
                incorrect_number_format:
                    'The value must be a number. Supported formats: 1000.0 and 1,000.0',
                incorrect_json: 'The value must ba a JSON',
                first_lower_case_letter: 'First letter must be in lower case',
                alias_validation: 'Only small letters, numbers and "_" are allowed',
            },
            roles: {
                admin: 'admin',
                user: 'user'
            },
            statuses: {
                recognition: {
                    done: 'Done',
                    error: 'Error',
                    recognizing: 'Recognizing',
                    waiting: 'Waiting'
                },
                approval: {
                    approved: 'Verified',
                    waiting_for_approval: 'Not verified'
                },
                payment: {
                    paid: 'Paid',
                    unpaid: 'Unpaid'
                },
                type: {
                    payable: 'Payable',
                    receivable: 'Receivable'
                },
                archive: {
                    archived: 'Archived',
                    unarchived: 'Unarchived'
                },
                export: {
                    exported: 'Already exported',
                    not_exported: 'Not exported'
                }
            },
            time: {
                minutesAgo: '%{count}min ago',
                hoursAgo: '%{count}h ago',
                daysAgo: '%{count}d ago',
                weeksAgo: '%{count}w ago'
            },
            notifications: {
                error_title: 'Error acquired',
                form_invalid: 'Form is invalid, please check errors',
                success_copy: 'Copied to Clipboard',
                unsuccessful_copy: 'Text has not been copied to Clipboard. Please, try again',
                error_copy: 'Error happened during copying text to Clipboard: {error}',
                element_updated: 'Element updated',
                element_deleted: 'Element deleted',
                element_deleted_plural: '{{count}} elements deleted',
                element_created: 'Element created',
                element_created_plural: '{{count}} elements created',
                download_file_fail: 'Failed to download file',
            },
            absentValuePlaceholder: 'Not found',
        },
        profile: {
            name: 'Profile',
            configuration: {
                fields: {
                    invoice_duration: 'Invoice duration',
                    xero_integration: 'Xero integration',
                    ocr_provider: 'OCR provider',
                    ocr_provider_pdf_text: 'PDF text processing'
                }
            },
            tabs: {
                configuration: 'Configuration',
                security: 'Security'
            },
            security: {
                name: 'Security',
                fields: {
                    old_password: 'Current password',
                    new_password: 'New password',
                    confirm_password: 'Confirm password'
                },
                notifications: {
                    keyGeneratedSuccessfully: 'API key generated successfully',
                    confirmation_email_sent: 'Confirmation email has been sent to your email',
                    password_changed_successfully: 'Password successfully changed',
                    invalid_password: 'Password is incorrect',
                    error: 'Error occurred'
                },
                validation: {
                    password_too_short: 'Password shall be not less than 6 characters long',
                    password_not_same: 'Passwords must be the same'
                },
                actions: {
                    save: 'Change password'
                }
            },
            apiKeys: {
                name: 'API keys',
                fields: {
                    accessToken: 'Access Token'
                }
            }
        },
        documents: {
            name: 'Documents',
            single: 'Document',
            exportSheetName: 'documents',
            delete_drop_zone: 'Drop here to delete',
            renew_date_message: 'until: {{renewDate}}',
            admin_counter_message: 'You have unlimited access to recognition',
            counter_message: 'Plan name: {{name}}\nData extraction pages used: {{dataExtractionUsed}}\nData extraction pages limit: {{dataExtractionLimit}}\nTotal pages used: {{recognizedPages}}\nTotal pages limit: {{allowedLimit}}\nBonus pages: {{bonusLimit}}\nUntil: {{to}}',
            default_template_recognition_message: 'Looks like currently ScanDocFlow app does not have rules for extracting properly all keyfields ' +
                'for uploaded document layout/supplier. The application will send a notification when the templates are created. ' +
                'Please check the app after notification, if you have any questions, please email us: support@scandocflow.com',
            notification: {
                approved_success: 'Document was verified',
                approved_error: 'Error: Document was not verified',
                archived_success: 'Document was archived',
                unarchived_success: 'Document was unarchived',
                unarchived_error: 'Error: Document was not unarchived',
                archived_error: 'Error: Document was not archived',
                make_paid_success: 'Document payment status was set to paid',
                make_unpaid_success: 'Document payment status was set to unpaid',
                make_paid_error: 'Error: payment status paid was not set',
                make_unpaid_error: 'Error: payment status error was not set',
                make_payable_success: 'Document type was set to bill to pay',
                make_receivable_success: 'Document type was set to invoice',
                make_payable_error: 'Error: document type was not set to bill to pay',
                make_receivable_error: 'Error: document type was not set to invoice',

                fieldsCalculationSuccess: 'Fields have been calculated',
                fieldsCalculationError: 'Error: fields haven\'t been calculated'
            },
            statusApproval: 'Verification status',
            fields: {
                exportTxt: {
                    url: 'Recognized text'
                },
                originalTotalPages: 'Amount of pages on original document',
                supplierId: 'Supplier',
                username: 'Username',
                filename: 'Filename',
                uploadDate: 'Uploading date',
                checksums: 'Validation checks',
                pageIndex: 'Page index',
                pagesTotal: 'Total pages',
                fieldName: 'Field name',
                fieldValue: 'Value',
                header: 'Header',
                invoiceNumber: 'Document number',
                invoiceFreight: 'Freight',
                otherFields: 'Full answer',
                template: 'Template',
                templateId: 'Template',
                documentType: 'Document type',
                documentTypeId: 'Document type',
                timer: 'From upload',
                startDate: 'Document date from',
                endDate: 'Document date to',
                publishedTo: 'Published to',
                publishedUnder: 'Published under',
                tags: 'Tags',
                pages: 'Pages',
                ocrProvider: 'OCR provider',
                ocrSplittingEngine: 'OCR splitting',
                splittingEngine: 'Splitting engine',
                documentLanguage: 'Document language',
                languageId: 'Document language',
                ocrLanguage: 'Document language',
                statusRecognition: 'Status',
                status_recognition: 'Status',
                statusApproval: 'Verification status',
                exportInfo: 'Export status',
                recognizingFinished: 'Recognizing finished',
                recognizingStarts: 'Recognizing starts',
                contentType: 'Content Type',
                year: 'Year',
                lineItems: 'Line items',
                requestId: 'Request id',
                traceId: 'Trace id',
                [waitingRecognitionStatus]: 'Waiting',
                [recognizingRecognitionStatus]: 'Recognizing',
                [doneRecognitionStatus]: 'Done',
                [errorRecognitionStatus]: 'Error',
                status: {
                    message: 'Error message'
                },
                data: {
                    totalQty: 'Total quantity',
                    currency: 'Currency',
                    currencyCode: 'Currency',
                    version: 'Version',
                    taxId: 'Tax id',
                    alias: 'Template alias',
                    username: 'Username',
                    filename: 'Filename',
                    supplierTaxId: 'Tax id',
                    supplierName: 'Supplier name',
                    number: 'Document number',
                    freight: 'Freight',
                    invoiceTotal: 'Total amount',
                    total: 'Total amount',
                    invoiceTotalQty: 'Total quantity',
                    invoiceSubtotal: 'Subtotal amount',
                    subtotal: 'Subtotal amount',
                    invoiceTax: 'Tax amount',
                    tax: 'Tax amount',
                    invoiceDate: 'Document date',
                    invoiceDateEpoch: 'Document date epoch',
                    date: 'Date',
                    invoiceDueDate: 'Document due date',
                    invoiceDueDateEpoch: 'Document due date epoch',
                    dueDate: 'Due date',
                    terms: 'Terms',
                    poNumber: 'PO Number',
                    statusIsArchived: 'Archive status',
                    template: 'Template',
                    documentType: 'Document type',
                    timer: 'Time from upload (HH:MM)',
                    startDate: 'Document date from',
                    endDate: 'Document date to',
                    publishedTo: 'Published to',
                    publishedUnder: 'Published under',
                    tags: 'Tags',
                    pages: 'Document pages/Total pages',
                    ocrProvider: 'OCR provider',
                    ocrSplittingEngine: 'OCR splitting',
                    splittingEngine: 'Splitting engine',
                    documentLanguage: 'Document language',
                    lineItems: 'Line items',
                    customerName: 'Customer Name',
                    routingNumber: 'Routing Number',
                    accountNumber: 'Account Number',
                    amount: 'Amount',
                    surnameUkr: 'Surname (ukr)',
                    surnameEng: 'Surname (eng)',
                    nameUkr: 'Name (ukr)',
                    nameEng: 'Name (eng)',
                    patronymic: 'Patronymic',
                    sex: 'Sex',
                    birthDate: 'Birth date',
                    expiryDate: 'Expiry date',
                    recordNumber: 'Record number',
                    documentNumber: 'Document number',
                    recognizedPlates: 'Recognized plates',
                    customerTaxId: 'Customer Tax Id',
                    vatRate: 'VAT rate',
                    customerCode: 'Customer code',
                    supplierCode: 'Supplier code',
                    type: 'Response document type',
                    series: 'Serial',
                    producer: 'Producer',
                    insured: 'Insured',
                    contactName: 'Contact Name',
                    phone: 'Phone',
                    fax: 'Fax',
                    email: 'Email',
                    certificateNumber: 'Certificate Number',
                    revisionNumber: 'Revision Number',
                    description: 'Description',
                    certificateHolder: 'Certificate Holder',
                    address: 'Address',
                    year: 'Year'
                }
            },
            list: {
                userTabs: {
                    all: 'All',
                    readyToExport: 'Ready for export',
                    needsAction: 'Action required',
                    analyzing: 'Analyzing',
                },
                errors_dialog: {
                    title: `Document {{documentId}} error`,
                    no_errors: 'There is no errors yet',
                    type: 'Summary:',
                    date: 'Date:',
                    message: 'Message:'
                },
                confirmDeleteDialogContent: 'Do you confirm deletion of {{count}} of your documents?',
                confirmDeleteDialogContentOtherUsers: 'Do you confirm deletion of {{count}} documents of <0>{{userCount}}</0> users?',
            },
            edit: {
                show_origin: 'Show origin',
                documentHistoryTitle: 'Actions performed on document:',
                totalPages: 'Total pages: {{totalPages}}',
                pages: 'Pages: {{fromPage}}-{{toPage}}',
                actions: {
                    download_original: 'Download original',
                    copyDocument: 'Copy',
                    copyDialogText: 'Select document type you want to copy to:',
                    confirmApproveDialog: {
                        title: 'Document contains checksums of warning level',
                        content: 'Do you want to approve document anyway?',
                    },
                    confirmDeleteDialogContent: 'Do you confirm deletion of document with id {{id}} of <0>{{username}}</0>?',
                },
                tabs: {
                    header: 'Header validation',
                    lineItems: 'Line items validation'
                },
                errors: {
                    numericLineItemValidationError: 'This field should be numeric',
                    columnExistedError: 'Column with such name already exists',
                    highlightNumericError: 'Selected value is not a number',
                    highlightDateError: 'Selected value is not a date',
                    highlightChooseField: 'Please choose the field you wanted to fill to',
                }
            },
            show: {
                tabs: {
                    headerView: 'View header',
                    lineItemsView: 'View line items'
                }
            },
            pdf: {
                original: 'Original',
                splitted: 'Categorized',
                recognized: 'Recognized',
                highlighted: 'Highlighted',
            },
            export: {
                dialogTitle: 'Export to Xero',
                multiple: 'Multiple (Line items)',
                single: 'Single (Header values)',
                optionsLabels: {
                    exportDocumentType: 'Publish as',
                    status: 'Status',
                    supplier: 'Contact',
                    bankAccount: 'Bank account',
                    creditNoteType: 'Credit note type',
                    accountCode: 'Account code',
                    currency: 'Currency',
                    lineAmountTypes: 'Tax type',
                    createRule: 'Save configuration',
                    publish_future_documents: 'Auto publish future documents'
                },
                types: {
                    purchase: 'Purchase',
                    invoice: 'Invoice (Rec)',
                    sendMoney: 'Send money',
                    creditNote: 'Credit note'
                },
                errors: {
                    noAccessToken: 'There is no access token for Xero',
                    expiredAccessToken: 'Your access token for Xero has expired',
                    somethingWentWrong: 'Something went wrong',
                    incorrect_toggles: 'For this option both toggles must be enabled'
                }
            },
            history: {
                data: 'Data',
                value: 'Value',
                basicTable: {
                    changeType: 'Change Type',
                    information: 'Information',
                    date: 'Date',
                    user: 'User',
                    more: 'More'
                },
                editData: {
                    changeType: 'Some data was edited',
                    data: 'Data',
                    old: 'Old',
                    new: 'New'
                },
                exportDocument: {
                    changeType: 'Document was exported',
                    publishedTo: 'Published To',
                    publishedAs: 'Published As',
                    documentId: 'Id'
                },
                exportDocumentError: {
                    changeType: 'Attempt to export the document',
                    publishedTo: 'Published To',
                    errorFailed: 'Error',
                    errorMsg: 'Error Message'
                },
                statusChanged: {
                    changeType: '',
                    status: 'Status',
                    old: 'Old',
                    new: 'New',
                    fields: {
                        [archivedStatus]: 'Document was archived',
                        [unarchivedStatus]: 'Document was unarchived',
                        [actionTypeStatusChanged]: 'Status of document was changed',
                        [actionTypeUploadingDocument]: 'Document was uploaded',
                        [waitingRecognitionStatus]: 'Document is waiting for recognition',
                        [recognizingRecognitionStatus]: 'Document is recognizing',
                        [doneRecognitionStatus]: 'Document was recognized',
                        [errorRecognitionStatus]: 'Document has error recognition',
                        [statusApprovalApproved]: 'Approval status was changed to Verified'
                    }
                },
                tagsChanged: {
                    changeType: 'Tags were changed',
                    old: 'Old',
                    new: 'New'
                },
                creation: {
                    uploading: 'Document was uploaded',
                    recognition: 'Document was created after recognition'
                },
                comment: {
                    changeType: 'Comment'
                },
                recognition: {
                    timeout: 'Document recognition time is expired',
                    send: 'Document was sent to recognition',
                    send_failed: 'Failed to send document to recognition',
                    changeType: 'Document was recognized',
                    status: 'Status',
                    recognizedFields: 'Recognized fields',
                    response: 'Responded error',
                    error: 'Error acquired during recognition',
                }
            },
            actions: {
                select_language: 'Select language',
                upload: 'Upload new document(s)',
                upload_disabled: 'Upload disabled, be sure You have chosen at least one document type',
            },
            lineItems: {
                add_new_column: 'Add new column',
                column_not_unique: 'Column name already existed!',
                invalid_column_name: 'Invalid column name!'
            },
            validationResults: {
                severityMapping: {
                    maxSeverityLevel: 'Max severity level',
                    calculatedSeverityLevel: 'Calculated severity level'
                },
                ruleResults: {
                    supplierNamePresent: 'Supplier name present',
                    totalOrSubtotalPresent: 'Total or subtotal present',
                    datePresent: 'Date present',
                    currencyCodePresent: 'Currency code present',
                    lineItemsCount: 'Line items count',
                    ocrVerificationStatusCheck: 'OCR verification status check',
                    recognitionStatusCheck: 'Recognition status check',
                    supplierNameAnnotations: 'Supplier name annotations',
                    customerNameAnnotations: 'Customer name annotations',
                    dateAnnotations: 'Date annotations',
                    dueDateAnnotations: 'Due date annotations',
                    termsAnnotations: 'Terms annotations',
                    numberAnnotations: 'Number annotations',
                    poNumberAnnotations: 'PO Number annotations',
                    subtotalAnnotations: 'Subtotal annotations',
                    taxAnnotations: 'Tax annotations',
                    totalAnnotations: 'Total annotations'
                }
            }
        },
        archives: {
            name: 'Archive'
        },
        rules: {
            name: 'Rules',
            single: 'Rule',
            no_options_for_integration: 'There is no enabled integrations for chosen document type',
            no_options_for_export_type: 'There is no enabled export types for chosen integration',
            fields: {
                createdAt: 'Created at',
                provider: 'Integration name',
                exportType: 'Export type',
                enabled: 'Publish future documents',
                update_rule: 'Update rule',
            },
        },
        tags: {
            name: 'Tags',
            single: 'Tag',
            fields: {
                name: 'Tag name',
                createdBy: 'Created by',
                createdAt: 'Created at',
                color: 'Color'
            }
        },
        suppliers: {
            name: 'Suppliers',
            vat: 'Supplier`s VAT',
            single: 'Supplier',
            fields: {
                name: 'Supplier name',
                templates_count: 'Templates count',
                documents_count: 'Documents count',
                users_count: 'UserProfile count',
                hot_suppliers_filter: 'Suppliers with > 1 document and 0 templates',
            }
        },
        templates: {
            name: 'Templates',
            single: 'Template',
            exportSheetName: 'templates',
            edit_template: 'Edit',
            add_template: 'Add',
            edit: {
                tabs: {
                    rawStyle: 'Raw style'
                }
            },
            fields: {
                has_collection: 'Has template collection',
                alias: 'Alias',
                template_data: 'Template data',
                last_modified_date: 'Modified date',
                document_id: 'Document id',
                collectionsCount: 'Collections count',
                template_collections: 'Templates collections'
            },
            errors: {
                constraints_absent: 'Template data needs to contain Constraints field',
                constraints_empty: 'Constraints field can\'t be empty',
                empty_documents: 'There are no documents related to current template'
            },
            notification: {
                document_not_found: 'Document with specified id does not exist',
                document_id_is_empty: 'Enter document id',
            }
        },
        templateCollections: {
            name: 'Template collections',
            single: 'Template collection',
            fields: {
                name: 'Collection name',
                templatesCount: 'Templates count',
                collections: 'Collections',
                batchVersion: 'Batch version'
            }
        },
        users: {
            name: 'Users',
            single: 'User',
            plan_data: 'Current plan boundaries: {{startTime}} - {{endTime}}, \n' +
                'Range number: {{rangeNumber}} \n Pages: {{recognizedPages}} / {{allowedLimit}}',
            fields: {
                id: 'Id',
                picture: 'Picture',
                role: 'Role',
                send_slack_notifications: 'Slack notifications',
                registrationDate: 'Registered',
                isPaid: 'Paid user',
                isPaidFull: 'Paid user (FastSpring)',
                isNotFree: 'Not free',
                isBlocked: 'Blocked user',
                emailVerified: 'Email verified',
                maxFreeRecognitionsCount: 'Count of pages for free recognition',
                email_verified: 'Email verified',
                plan: 'Subscription plan',
                showAllUserDocuments: 'Documents',
                showUserActions: 'Actions',
                ocrProviderPostProcess: 'Post-processing',
                isTestUser: 'Test User'
            },
            actions: {
                registration_success: `User successfully registered`,
                verification_email_sent: 'Verification email was successfully sent',
                email_verified: 'Email successfully verified',
                forgot_password: 'Forgot password',
            },
            email: {
                dialog_title: 'Email verification',
                dialog_content: 'Please check {{email}} to verify your email address',
                actions: {
                    send_again: 'Send letter again',
                    send_again_timer: 'Send again in {{timer}} seconds',
                    re_send_verification_letter: 'Re-send verification letter',
                },
                notifications: {
                    send_success: 'Verification letter was successfully sent',
                },
            },
            notifications: {
                passwordChanged: 'Password has been successfully changed.',
            },
        },
        documentTypes: {
            name: 'Document types',
            description: 'Please select the document types that you would like to use in the system. After saving the configuration, chose document types will appear in the left-side menu',
            single: 'Document type',
            validation: {
                xero_integration_mismatch: 'Xero integration cannot be available when there is no field with type "Supplier"',
                integrations_mismatch: 'Integrations cannot be available when there is no field with type "Supplier"',
                jsonValidationError: 'Not JSON format',
                id_validation: 'Id must start with lower case letter and contain only: letters, numbers or "_"',
                fileExtensionsValidation: 'You have to choose at least 1 file extension',
            },
            actions: {
                add_new_field: 'Add new field',
                remove_field: 'Remove field',
                upload_image: 'Upload preview image'
            },
            field_types: {
                text: 'Text',
                text_extended: 'Text extended',
                long_text: 'Multiline',
                date: 'Date',
                number: 'Number',
                currencyNumber: 'Currency number',
                currency: 'Currency',
                flat_table: 'Flat table',
                supplier: 'Supplier',
                ocr_text: 'Ocr text',
            },
            fields: {
                id: 'Id',
                ocr_version: 'OCR engine version',
                allowed_for_user: 'Allowed for user',
                useTemplatesShort: 'Uses templates',
                isDefaultShort: 'Available for new users',
                integrations: 'Integrations',
                show_highlights: 'Show highlights',
                showResponseFields: 'Show fields from response',
                ocr_provider_post_process: 'Post-processing',
                postProcessingEnabled: 'Enabled',
                postProcessingDisabled: 'Disabled',
                fileFormats: 'Appropriate file formats',
                previewTitle: 'Preview title',
                description: 'Description',
                image_preview: 'Document example',
                image: 'Document type preview image',
                requestQueueUrl: 'Queue URL for sending requests',
                useTemplates: 'Does this document type uses templates',
                templatesBatchName: 'Templates batch name',
                isDefault: 'Does this document type available for newly registered users',
                weight: 'Sorting weight',
                xero_integration: 'Xero integration',
                name: 'Display name',
                color: 'Color',
                fields_title: 'Document type fields',
                field_name: 'Field name',
                field_type: 'Field type',
                extended: 'Extended',
                documentTypesRequestMarker: 'Field documentTypes in request',
                default_language: 'Default language',
                default_provider: 'Default provider',
                user_defined: 'Defined by user settings',
            }
        },
        statistics: {
            name: 'Statistics',
            empty_records: 'There is no statistics',
            fields: {
                month: 'Month',
                day: 'Day',
                number_of_last_pages: 'Pages in period',
                request_id: 'Request id',
                uploaded_time: 'Uploading time',
                recognition_end_time: 'Recognition end time',
                number_of_uploaded: 'Number of uploaded documents',
                number_of_pages: 'Number of recognized pages',
                status: 'Status',
                uploading_source: 'Uploading source',
                requestscount: 'Requests count',
                documentscount: 'Documents count',
                pagescount: 'Pages count',
                startTime: 'Start',
                endTime: 'End',
                days: 'day(s)',
                daysCapitalized: 'Days',
            },
            actions: {
                reset_filters: 'Reset filters'
            },
            statuses: {
                error: 'Error',
                finished: 'Received recognition response',
                uploading: 'Uploading documents',
                waiting: 'Waiting for recognition response'
            }
        },
        recognitionBonuses: {
            name: 'Bonuses',
            single: 'Recognition bonus',
            dialog_title: 'Add bonuses to user',
            end_time_helper_text: 'Leave empty to set bonus till the end of current period',
            fields: {
                additional_pages: 'Number of additional pages',
                end_time: 'End time',
                end_time_utc: 'End time in UTC',
                enabled: 'Enabled',
                range_number: 'Range',
            },
            tabs: {
                all_bonuses: 'All user bonuses',
                add_bonus: 'Add new bonus',
            },
            notifications: {
                update_success: 'Element updated',
            },
        },
        apiKeys: {
            documentation: 'API documentation',
            name: 'Api Keys',
            single: 'Api Key',
            create_error_notification: 'Error happened during creating API key: %{error}',
            open_documentation: 'Open API documentation',
            fields: {
                number_of_requests: 'Number of requests',
                enabled: 'Enabled',
                disabled: 'Disabled',
                tokenId: 'Token',
                created: 'Created',
                allowedBySystem: 'Allowed by system',
                allowedIps: 'Allowed IPs',
                ip: 'IP',
                source: 'Source',
                ttl: 'Expires at',
            },
            options: {
                active: 'Active',
                allowedBySystem: 'Allowed by system',

                enabled: 'Enabled',
                disabled: 'Disabled'
            },
            actions: {
                generate: 'Generate new API key',
                system_disable: 'Disable',
                add_new_ip: 'Add new IP',
                remove_ip: 'Remove IP',
            },
            create_result_dialog: {
                title: 'New API key',
                loading_title: 'Creating new API key',
                text: 'Please, copy new API key and store it in a safe place, because token will not be shown in the future',
                loading_text: 'Please, wait we are creating API key...',
            },
            notifications: {
                disable_by_system_success: 'API keys has been disabled by system',
                disable_by_system_fail: 'Error acquired during disabling keys by system',
            },
        },
        user_tour: {
            name: 'User tour',
            steps: {
                choose_doc_type: 'Choose document type',
                open_document_uploading: 'Open document(s) uploading',
                upload_document: 'Choose document(s) language and upload them',
                wait_for_recognition: 'Wait for document recognition. Press "Next" when it ends',
                go_to_edit: 'Go to document edit to see extracted values',
                congratulations: 'Congratulations, You`ve ended user guide. You always can start it again via this element',
            },
        },
        forgot_password: {
            change_password_email_sent: 'Letter with instructions to reset password has been sent to ',
            forgot_password: 'Forgot password',
            reset_password: 'Reset password',
            forgot_password_suggestion: 'Please, input an email you have registered with:',
            password_changed: 'Password has been successfully changed',
            invalidResetPasswordCallback: 'Reset password callback is invalid'
        },
        changePasswordConfirm: {
            passwordChangedSuccessfully: 'Password changed successfully',
        },
        changePassword: {
            title: 'Create a new password:'
        },
        integrations: {
            name: 'Integrations',
            single: 'Integration',
            connection_message: 'Please connect to integration first',
            fields: {
                integration_name: 'Integration name',
                enabled: 'Connection status',
                export_as: 'Export as',
                exported_to: 'Exported to: ',
                exported_to_title: 'Document exports',
                external_organisation_name: 'External organisation name',
                export_timestamp: 'Export date',
            },
            notifications: {
                connect: 'Connect',
                connect_success: 'Successfully connected',
                connect_fail: 'Failed to connect',
            },
            export_as: {
                headers: 'Header values',
                line_items: 'Line items',
            },
            actions: {
                sync_data: 'Sync data',
                sync_data_success: 'Data synced successfully',
                sync_data_fail: 'Failed to sync data',
                disconnect: 'Disconnect',
                connect: 'Connect',
                disconnect_success: 'Integration disconnected successfully',
                disconnect_fail: 'Failed to disconnect from integrations',
                sent_to_queue: 'Sent to queue',
                sent_to_queue_success: 'Successfully sent document {{ids}} to export queue',
                sent_to_queue_success_plural: 'Successfully sent {{count}} documents to export queue. Document ids: {{ids}}',
                sent_to_queue_fail: 'Failed to send document to export queue',
                sent_to_queue_fail_plural: 'Failed to send {{count}} documents to export queue. Document ids: {{ids}}',
                sent_to_queue_fail_with_message: 'Failed to send document {{ids}} to queue. Error: {{message}}',
                sent_to_queue_fail_with_message_plural: 'Failed to send {{count}} documents to queue. Error: {{message}}, Ids: {{ids}}',
                export: 'Export',
                export_to: 'Export to {{provider}}',
            },
            connection_status: {
                0: 'Not connected',
                1: 'Connected',
            },
            accounting_suite: {
                name: 'AccountingSuite',
                export_as: {
                    invoice: 'Sales Invoice',
                },
                fields: {
                    currency: 'Currency',
                    company: 'Company',
                },
            },
            xero: {
                fields: {
                    amount_type: 'Tax type',
                    bank_account: 'Bank account',
                    account: 'Account',
                    credit_note_type: 'Credit note type',
                    credit_note_status: 'Credit note status',
                    invoice_status: 'Invoice status',
                    tax_rate: 'Tax rate',
                },
            },
            fresh_books: {
                actions: {
                    choose_organisation: 'Choose business',
                },
                fields: {
                    tax_rate: 'Tax rate',
                    category: 'Category',
                    vendor: 'Vendor',
                    business: 'Business name',
                    client: 'Client',
                },
            },
            quick_books: {
                fields: {
                    export_document_type: 'Export document type',
                    account_code: 'Account code',
                    tax_code: 'Tax code',
                    customer: 'Customer',
                    vendor: 'Vendor',
                    default_item_type: 'Default item type',
                    default_income_account: 'Default income account',
                    default_asset_account: 'Default asset account',
                    default_expense_account: 'Default expense account',
                },
            },
        },
        configs: {
            name: 'Configurations',
            fields: {
                helper_text: 'Helper text',
                provider: 'Integration name',
                path: 'Path',
                name: 'Name',
                label: 'Label',
            },
            export_config: {
                name: 'Export configuration',
                tabs: {
                    fields_mapping: 'Fields mapping',
                    stages_config: 'Stages config',
                    common_data: 'Common data',
                },
                fields: {
                    key: 'Key',
                    path: 'Path',
                    required: 'Required',
                    is_line_items: 'Is line items',
                    executor: 'Executor function name',
                    dependencies: 'Dependencies stages',
                    accepts: 'Accepts',
                    returns: 'Returns',
                    disabled: 'Disabled (use ONLY for debug)',
                    name: 'Stage name',
                    param_name: 'Param name',
                    type: 'Type',
                    type_choices: {
                        empty: 'No type (text)',
                        date: 'Date',
                    },
                },
            },
            rules_config: {
                name: 'Rules configuration',
                fields: {
                    export_type: 'Export type',
                    options: 'Rule options',
                    id_render_field: 'Field used as Id',
                    name_render_field: 'Field used as Name',
                    type: 'Field type',
                    type_choices: {
                        autocomplete: 'Autocomplete',
                        radio: 'Radio',
                        autocomplete_with_create: 'Autocomplete with create',
                        boolean: 'Boolean',
                    },
                },
            }
        },
        userHistory: {
            name: "Actions",
            fields: {
                id: 'Id',
                ip: 'IP',
                date: 'Date',
                username: 'Username',
                category: 'Category',
                type: 'Type',
                action: 'Action',
                diff: 'Changed data',
                documentHistory: 'Document history'
            },
            filters: {
                startDate: 'Date from',
                endDate: 'Date to'
            },
            categories: {
                user: 'User',
                api_key: 'Api key',
                document: 'Document',
                document_type: 'Document type',
                supplier: 'Supplier',
                template: 'Template',
                template_collection: 'Template collection'
            },
            types: {
                create: 'Create',
                update: 'Update',
                delete: 'Delete',
                register: 'Registration',
                login: 'Login',
                logout: 'Logout',
                change_password: 'Change password',
                disable: 'Disable',
                export_to_xero: 'Export to Xero',
            }
        },
        documentHistory: {
            actionType: 'Action type',
            actionDate: 'Action date',
            actionData: 'Action data',
            permissionsLevel: 'Permissions level',
        },
        requests: {
            name: "Requests",
            fields: {
                id: 'Id',
                apiKey: 'Api key',
                userName: "Username",
                userId: "User id",
                uploadingSource: "Uploading source",
                uploadedTime: 'Created date',
                requestDuration: 'Duration (sec)',
                status: "Request status",
                webhookStatus: "Webhook status",
                webhookUrl: "Webhook url",
                reSendWebhook: "Re-send webhook",
                requestParams: "Request parameters",
                errorMessage: "Error message",
                uploadingIp: "IP",
                receivedDocuments: 'Documents',
                recognizedPages: 'Recognized pages',
                uploadedDocuments: 'Uploaded documents',
            },
            statuses: {
                [requestStatusError]: 'Error',
                [requestStatusSuccess]: 'Success',
                [requestStatusRunning]: 'Running',
                [webhookStatusNotSent]: 'Not sent',
            },
            uploadingSources: {
                [customTokenSourceApiAsync]: 'Api async',
                [customTokenSourceApiSync]: 'Api sync',
                [customTokenSourceWeb]: 'Web',
            },
            filters: {
                startDate: "Created date from",
                endDate: "Created date to",
            },
            statistics: {
                title: 'Requests count',
                groupBy: 'Group by',
                docTypes: 'Document types',
                tooltipFormat: '%{key}: %{value}'
            }
        }
    }
};
